(() => {
  const trackedFrames = new WeakSet();
  const orderTitleDocuments = new WeakSet();
  const frameIds = new Set(['chat-window', 'chat-button', 'chat-campaigns', 'chat-input']);
  const css = `
    #conversation-floating-header button[aria-label="Bestellstatus"] svg,
    #conversation-floating-header button[aria-label="Order status"] svg,
    #conversation-floating-header button[aria-label="Track orders"] svg {
      background: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%3E%3Cpath%20d%3D%22m12%203%208.2%204.7v8.6L12%2021l-8.2-4.7V7.7L12%203Z%22%20fill%3D%22none%22%20stroke%3D%22black%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22m3.8%207.7%208.2%204.7%208.2-4.7M12%2012.4V21M7.9%205.35l8.2%204.7%22%20stroke%3D%22black%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E") center / contain no-repeat !important;
    }
    #conversation-floating-header button[aria-label="Bestellstatus"] svg path,
    #conversation-floating-header button[aria-label="Order status"] svg path,
    #conversation-floating-header button[aria-label="Track orders"] svg path {
      opacity: 0 !important;
    }
    html body, html body :is(button, input, textarea, select, p, a, span, div, label, h1, h2, h3, h4, h5, h6, li) {
      font-family: "futura-pt", Arial, Helvetica, sans-serif !important;
    }
    #header-view-cart-button svg path,
    #conversation-floating-header button[aria-label="Schließen"] svg path,
    #conversation-floating-header button[aria-label="Close"] svg path {
      stroke-width: 1.25 !important;
    }
    [data-cascas-order-status-title],
    [data-cascas-order-status-title] * {
      font-weight: 500 !important;
    }
    #homepage-header img[alt="CASCAS Support logo"] {
      visibility: hidden !important;
    }
    #mountHere > .frame-content > [role="dialog"][aria-labelledby="gorgias-chat-dialog-title"] {
      background: #eeeeee url("https://cdn.shopify.com/s/files/1/0703/9464/2696/files/cascas-chat-background-blindpraegung.png?v=1792253382") right bottom / cover no-repeat !important;
    }
    #self-service-portal-container div:has(> div > canvas),
    #conversation,
    #conversation div:has(> div > span > button[role="button"][aria-label^="Send "]) {
      background: transparent !important;
    }
    #self-service-portal-container canvas {
      display: none !important;
    }
    #conversation strong,
    #conversation b,
    #conversation button[role="button"][aria-label^="Send "] {
      font-weight: 400 !important;
    }
  `;

  function styleFrame(frame) {
    try {
      const doc = frame.contentDocument;
      if (!doc?.head) return;
      if (!orderTitleDocuments.has(doc)) {
        orderTitleDocuments.add(doc);
        const softenOrderTitle = () => {
          doc.querySelectorAll('button, [role="button"]').forEach(button => {
            const labels = [button.getAttribute('aria-label'), button.getAttribute('title'), button.innerText, button.textContent];
            const isOrderTitle = labels.some(label => /^(Bestellstatus|Order status)$/i.test((label || '').trim()));
            if (button.hasAttribute('data-cascas-order-status-title') !== isOrderTitle) button.toggleAttribute('data-cascas-order-status-title', isOrderTitle);
          });
        };
        const titleObserver = new MutationObserver(softenOrderTitle);
        titleObserver.observe(doc.documentElement, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'title']});
        softenOrderTitle();
      }
      if (!doc.getElementById('cascas-gorgias-font')) {
        const link = doc.createElement('link');
        link.id = 'cascas-gorgias-font';
        link.rel = 'stylesheet';
        link.href = 'https://use.typekit.net/iiz7owd.css';
        doc.head.append(link);
      }
      if (!doc.getElementById('cascas-gorgias-brand')) {
        const style = doc.createElement('style');
        style.id = 'cascas-gorgias-brand';
        style.textContent = css;
        doc.head.append(style);
      }
    } catch (_) {}
  }

  const launcherStyle = document.createElement('style');
  launcherStyle.textContent = `
    #gorgias-chat-container #chat-button {
      transition: opacity 140ms ease, visibility 0s;
    }
    #gorgias-chat-container #chat-button[data-cascas-footer-hidden] {
      opacity: 0 !important;
      visibility: hidden !important;
      pointer-events: none !important;
      transition: opacity 140ms ease, visibility 0s 140ms;
    }
    @media (prefers-reduced-motion: reduce) {
      #gorgias-chat-container #chat-button,
      #gorgias-chat-container #chat-button[data-cascas-footer-hidden] { transition: none; }
    }
  `;
  document.head.append(launcherStyle);
  let launcherFrame = 0;
  function scheduleLauncher() {
    if (launcherFrame) return;
    launcherFrame = requestAnimationFrame(() => {
      launcherFrame = 0;
      const launcher = document.getElementById('chat-button');
      if (!launcher) return;
      const height = Math.max(document.documentElement.scrollHeight, document.body?.scrollHeight || 0);
      const atBottom = height - window.innerHeight - window.scrollY <= 4;
      if (launcher.hasAttribute('data-cascas-footer-hidden') !== atBottom) {
        launcher.toggleAttribute('data-cascas-footer-hidden', atBottom);
      }
    });
  }
  window.addEventListener('scroll', scheduleLauncher, {passive: true});
  window.addEventListener('resize', scheduleLauncher, {passive: true});
  window.addEventListener('pageshow', scheduleLauncher);
  window.visualViewport?.addEventListener('resize', scheduleLauncher, {passive: true});
  const launcherResizeObserver = new ResizeObserver(scheduleLauncher);
  launcherResizeObserver.observe(document.documentElement);

  function update() {
    scheduleLauncher();
    const container = document.getElementById('gorgias-chat-container');
    if (!container) return;
    container.querySelectorAll('iframe').forEach(frame => {
      if (!frameIds.has(frame.id)) return;
      if (!trackedFrames.has(frame)) {
        trackedFrames.add(frame);
        frame.addEventListener('load', () => styleFrame(frame));
      }
      styleFrame(frame);
    });
  }

  function localizeOrderLabels() {
    try {
      const chat = window.GorgiasChat;
      if (typeof chat?.printLabelDictionary !== 'function' || typeof chat.updateSSPTexts !== 'function') return;
      const texts = chat.printLabelDictionary()?.sspTexts;
      const labels = {};
      ['yourOrders', 'seeOrders'].forEach(key => {
        if (texts?.[key] === 'Ihre Bestellungen') labels[key] = 'Deine Bestellungen';
      });
      if (Object.keys(labels).length) chat.updateSSPTexts(labels);
    } catch (_) {}
  }

  window.addEventListener('gorgias-widget-loaded', localizeOrderLabels);
  if (window.GorgiasChat?.init) {
    window.GorgiasChat.init().then(localizeOrderLabels).catch(() => {});
  }

  const observer = new MutationObserver(update);
  observer.observe(document.documentElement, {childList: true, subtree: true});
  window.addEventListener('gorgias-widget-loaded', update);
  window.addEventListener('pagehide', () => observer.disconnect(), {once: true});
  update();
})();

